import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TrasladosLocalesList = ({ data, onDelete, onEdit }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    onDelete(item);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  )
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    align: 'center',
    key: 'ImpLocTrasladado',
    title: 'Imp. Loc. Trasladado',
    dataIndex: 'ImpLocTrasladado',
  },
  {
    align: 'center',
    key: 'TasadeTraslado',
    title: 'Tasa de Traslado',
    dataIndex: 'TasadeTraslado',
  },
  {
    align: 'center',
    key: 'Importe',
    title: 'Importe',
    dataIndex: 'Importe',
  },
];

export default TrasladosLocalesList;